import React from 'react';
import PropTypes from 'prop-types';
import { Input, Dropdown } from 'shared-components';
import Label from '../../components/Label';
// Import Component Styles
import { StyledInputGroup, StyledLabelGroup } from './styles';

const isField = child => child.type === Input || child.type === Dropdown;

// Gives the field id={labelFor} so the label points at it. Looks inside wrappers like
// the password eye-button group; other direct children (EditableDropdown) take it as is.
const withFieldId = (children, id) => {
  let found = false;
  const visit = nodes => React.Children.map(nodes, child => {
    if (found || !React.isValidElement(child)) return child;
    if (isField(child)) {
      found = true;
      return child.props.id ? child : React.cloneElement(child, { id });
    }
    if (!child.props.children || typeof child.props.children === 'function') return child;
    return React.cloneElement(child, { children: visit(child.props.children) });
  });

  const visited = visit(children);
  if (found) return visited;

  return React.Children.map(children, (child, index) => {
    if (index !== 0 || !React.isValidElement(child) || child.props.id) return child;
    return React.cloneElement(child, { id });
  });
};

const InputGroup = ({
  label,
  labelFor,
  dataId,
  required,
  tooltip,
  page,
  children,
}) => (
  <StyledInputGroup data-id={dataId}>
    <StyledLabelGroup>
      <Label
        labelFor={labelFor}
        label={label}
        page={page}
        required={required}
      />
      {tooltip}
    </StyledLabelGroup>
    {withFieldId(children, labelFor)}
  </StyledInputGroup>
);

InputGroup.propTypes = {
  label: PropTypes.node.isRequired,
  labelFor: PropTypes.string.isRequired,
  dataId: PropTypes.string,
  required: PropTypes.bool,
  tooltip: PropTypes.element,
  page: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default InputGroup;
